import React from 'react';
import styles from './style.css';

const Logo = () => {
    return (
        <div className={styles.mainSquare}>
            <div className={styles.square1}/>
            <div className={styles.square2}/>
            <div className={styles.square3}/>
            <div className={styles.square4}/>
        </div>
    );
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo/index.js